'use strict';
'use es6';

Object.defineProperty(exports, "__esModule", {
  value: true
});

var _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };

var _react = require('react');

var _classNames = require('react-utils/classNames');

var _classNames2 = _interopRequireDefault(_classNames);

var _getComponentName = require('react-utils/getComponentName');

var _getComponentName2 = _interopRequireDefault(_getComponentName);

var _utils = require('./utils');

var _Functions = require('../core/Functions');

var _SyntheticEvent = require('../core/SyntheticEvent');

var _SyntheticEvent2 = _interopRequireDefault(_SyntheticEvent);

var _decorators = require('../utils/propTypes/decorators');

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

function _objectWithoutProperties(obj, keys) { var target = {}; for (var i in obj) { if (keys.indexOf(i) >= 0) continue; if (!Object.prototype.hasOwnProperty.call(obj, i)) continue; target[i] = obj[i]; } return target; }

var computeHovered = function computeHovered(hoveredProp, hoveredState) {
  return (hoveredProp != null ? hoveredProp : hoveredState) || false;
};

var Hoverable = (0, _utils.eventHandlerDecoratorFactory)({
  displayNameFunc: function displayNameFunc(Component) {
    return 'Hoverable(' + (0, _getComponentName2.default)(Component) + ')';
  },

  propTypes: {
    hovered: (0, _decorators.hidden)(_react.PropTypes.bool),
    onHoveredChange: (0, _decorators.hidden)(_react.PropTypes.func)
  },

  defaultProps: {
    hovered: undefined
  },

  initialState: {
    hovered: undefined
  },

  eventHandlers: {
    onMouseEnter: function onMouseEnter() {
      if (this.state.hovered === true) return;
      this.setState({ hovered: true });
      (0, _Functions.callIfPossible)(this.props.onHoveredChange, (0, _SyntheticEvent2.default)(true));
    },
    onMouseLeave: function onMouseLeave() {
      if (this.state.hovered === false) return;
      this.setState({ hovered: false });
      (0, _Functions.callIfPossible)(this.props.onHoveredChange, (0, _SyntheticEvent2.default)(false));
    },
    onMouseMove: function onMouseMove() {
      // See https://git.hubteam.com/HubSpot/UIComponents/issues/3927
      if (this.state.hovered === true) return;
      this.setState({ hovered: true });
      (0, _Functions.callIfPossible)(this.props.onHoveredChange, (0, _SyntheticEvent2.default)(true));
    }
  },

  shouldComponentUpdate: function shouldComponentUpdate(nextProps) {
    // Avoid unnecessary updates when state.hovered changes but we're controlled.
    if (this.props !== nextProps) return true;
    return nextProps.hovered == null;
  },
  getPropsForRender: function getPropsForRender(props, state) {
    var className = props.className,
        rest = _objectWithoutProperties(props, ['className']);

    var hovered = computeHovered(props.hovered, state.hovered);
    return _extends({}, rest, {
      hovered: hovered,
      className: (0, _classNames2.default)(className, {
        'private-hovered': hovered
      })
    });
  }
});

exports.default = Hoverable;
module.exports = exports['default'];


//////////////////
// WEBPACK FOOTER
// /usr/share/hubspot/build/.hubspot/static-archive/UIComponents/static-2.2644/js/decorators/Hoverable.js
// module id = 141
// module chunks = 3 4 5